export default {"src":"/_next/static/media/INTC.4075dcb2.svg","height":18,"width":18};